@use "@fukuri-admins/ui/layout" as *;

.container {
  display: flex;
  flex-direction: column;
  gap: spacing("24");
}
